import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as OnTapActions from './actions'
import { IOntapTVPendingConnection } from 'app/models/ontapTVPendingConnections';

export interface State extends EntityState<IOntapTVPendingConnection> {
  // additional entity state properties
  selectedId: string | null;
  error: string;
}


export function selectId(a: IOntapTVPendingConnection): string {
  return a.id ?? '';
}
export const adapter: EntityAdapter<IOntapTVPendingConnection> = createEntityAdapter<IOntapTVPendingConnection>({
  selectId: selectId
});

export const initialState: State = adapter.getInitialState({
  selectedId: null,
  error: ''
});

export const stateName = 'ontapTvPendingConnections';

export const reducer = createReducer<State>(
  initialState,

);

// get the selectors
const { selectAll, selectEntities } = adapter.getSelectors();

// Export selectAll for effect caching
export { selectAll };

const onTapBasicState = createFeatureSelector<State>(stateName);
export const selectAllItems = createSelector(onTapBasicState, selectAll);
export const selectAllEntities = createSelector(onTapBasicState, selectEntities);
export const selectEntity = (id: string) => createSelector(selectAllEntities, entities => entities[id]);
